import React from "react";
import { NextIsAgainFree, NextIsPaid, NextIsReadOnly, NextIsCancelled, NotImplementedSubscription } from "../../../Subscription/Components/CommonPanelContent";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const FreeSubscription = (props: Props) => {
  switch (props.nextSubscriptionType.value) {
    case "free":
      return <NextIsAgainFree />;
    case "paid":
      return <NextIsPaid {...props} />;
    case "readOnly":
      return <NextIsReadOnly {...props} />;
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return <NextIsCancelled {...props} tip="readOnly" />;
    default:
      return <NotImplementedSubscription />;
  }
};

export default FreeSubscription;
